import { render } from "./FeedItem.vue?vue&type=template&id=39c0feb7&scoped=true"
import script from "./FeedItem.vue?vue&type=script&lang=js"
export * from "./FeedItem.vue?vue&type=script&lang=js"

import "./FeedItem.vue?vue&type=style&index=0&id=39c0feb7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c0feb7"]])

export default __exports__